import { ComponentType } from 'react';
import { UIMatch } from 'react-router-dom';

export interface RouteHandle {
  header?: ComponentType;
  isFullBleed?: boolean;
  titleKey?: string;
}

const isRouteHandle = (handle: unknown): handle is RouteHandle =>
  typeof handle === 'object' && handle !== null;

export const deepestRouteHandle = (matches: UIMatch[]): RouteHandle =>
  matches.map(({ handle }) => handle).findLast(isRouteHandle) ?? {};

export const deepestRouteTitleKey = (matches: UIMatch[]) =>
  matches
    .map(({ handle }) => handle)
    .filter(isRouteHandle)
    .findLast((handle) => Boolean(handle.titleKey))?.titleKey;
